import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { map, switchMap } from 'rxjs';

import { DynamicFormRendererComponent } from '../components/dynamic-form-renderer/dynamic-form-renderer.component';
import { DynamicFormsService } from '@services/dynamic-forms.service';

@Component({
  selector: 'cvx-dynamic-form-runtime-page',
  standalone: true,
  imports: [CommonModule, RouterModule, DynamicFormRendererComponent],
  templateUrl: './dynamic-form-runtime-page.component.html',
  styleUrl: './dynamic-form-runtime-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormRuntimePageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly service = inject(DynamicFormsService);

  protected readonly form = toSignal(
    this.route.paramMap.pipe(
      map((params) => params.get('id') ?? ''),
      switchMap((id) => this.service.getById(id))
    ),
    { initialValue: null }
  );
}
